<template>
  <div id="home">
  
    <div class="pillars-toggle" v-if="current != 0">
    <!--<a href="#"><img src="../assets/images/Contrast_Logo1.png" width=10 height=10 /></a>-->
    <button onclick="window.location.href = 'https://contrastvr.com';" target="_blank" :style="`background-image: url(${LOGO});width:2.3em;margin-left:0.5em;background-size:2.3em;height:4em`"></button>
      <button @click="togglePillars" :style="`background-image: url(${ICON})`"></button>
    </div>
    <nav :style="{visibility: !pVisible ? 'visible' : 'hidden'}">
      <ul :style="{'grid-template-rows':'repeat('+navBar.length+', minmax(0.2em, 1fr))'}">
        <li v-for="nav in navBar"  :value="nav.index" @click="() => { go(nav.index);}">
          <div class="tooltip">{{nav.title}}</div>
          <div class="nav-item"></div>
        </li>
      </ul>
    </nav>

<transition name="fade" mode="in-out">
<aside class="about" v-if="isAboutVisible" @wheel.stop>
      <button @click="isAboutVisible = false" class="close-btn black-btn">
        <svg
          width="20"
          height="20"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 64 64"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          enable-background="new 0 0 64 64"
        >
          <g>
            <path
              fill="#FFF"
              d="M28.941,31.786L0.613,60.114c-0.787,0.787-0.787,2.062,0,2.849c0.393,0.394,0.909,0.59,1.424,0.59   c0.516,0,1.031-0.196,1.424-0.59l28.541-28.541l28.541,28.541c0.394,0.394,0.909,0.59,1.424,0.59c0.515,0,1.031-0.196,1.424-0.59   c0.787-0.787,0.787-2.062,0-2.849L35.064,31.786L63.41,3.438c0.787-0.787,0.787-2.062,0-2.849c-0.787-0.786-2.062-0.786-2.848,0   L32.003,29.15L3.441,0.59c-0.787-0.786-2.061-0.786-2.848,0c-0.787,0.787-0.787,2.062,0,2.849L28.941,31.786z"
            />
          </g>
        </svg>
      </button>

      <div class='about-content'>
        <div class="container-fluid h-100 aboutdisplay" :style="`min-height:100%;background-size:cover;background-image: url(${PHOTO});`">
    <div class="last-page">
    <div class="row h-100">
    <div class="col h-100" style="font-size:3vw;">
      <div class="row no-gutters share-icons">
        <div class="share-icons-container">
          <h2 style="font-size:0.8em;text-align:center;">SHARE THIS STORY</h2>

          <div class="social-icons">
            <a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https://ajcontrast.com/uighurs"><font-awesome-icon :icon="['fab', 'facebook-f']"  /></a>

            <a target="_blank" href="https://twitter.com/intent/tweet?text=Living%20in%20the%20Unknown&url=https://ajcontrast.com/uighurs"><font-awesome-icon :icon="['fab', 'twitter']"  /></a>


            <a target="_blank" href="https://api.whatsapp.com/send?text=Explore%20the%20Uighur%20culture%20through%20the%20three%20pillars%20of%20their%20identity%20most%20under%20attack.%0D%0Ahttps://ajcontrast.com/uighurs"><font-awesome-icon :icon="['fab', 'whatsapp']"  /></a>
          </div>
          
        </div>
      </div>
          <div class="row no-gutters">
          <div class="credits">
          <b-img :src="`${require('@/assets/images/credits.png')}`" fluid />
          </div>
          </div>
      </div>
      <div class="col" style="font-size:3vw;">
      <div class="more-information">
        <div class="more-information-container">
          <h2 style="font-size:0.8em;">MORE ON UIGHURS IN TURKEY</h2>
          <a href="https://contrastvr.com/uighurs" rel="_blank">
          <div style="
    width: 7em;
    text-align: center;
    margin: 0 auto;
">
          <b-img fluid :src="`${require('@/assets/images/living.png')}`" />
          </div>
          </a>
          
          <div class="learnmoredoc">
    To learn more, watch AJ Contrast's original<br> 360° documentary "Living in the Unknown"
    </div>
        </div>
      </div>
      
      </div>
      </div>
    </div>
  </div>
      </div>
    </aside>
    </transition>

    <div class="slides">
      <section
        :class="['slide', current == index && 'active']"
        v-for="(view, index) in views"
        :key="index"
      >
        <component
          v-if="current == index"
          :is="view.component"
          :isVisible="current == index"
          v-on:next="next"
          v-on:prev="prev"
          v-on:go="go"
          :photoCard="view.photoCard"
          :popupVideo="view.popupVideo"
          :withCarousel="view.withCarousel"
          v-on:play-audio="playAudio"
          v-on:stop-audio="stopAudio"
          v-on:stop-all-audio="stopAllAudio"
          v-on:popUpVisible="pVisible = $event"
          :scroll="scroll"
          :videos="view.videos"
          :photo="view.photo"
          :tapes="view.tapes"
          :poster="view.poster"
          :showcontrols="view.showcontrols"
          :disablebackscroll="view.disablebackscroll"
          :clicktoplay="view.clicktoplay"
          :loop ="view.loop"
          :showfirsttape = "view.showfirsttape"
          :noscroll = "view.noscroll"
          :noaudio="view.noaudio"
          :pauses="view.pauses"
          :parentCurrent="current"
          :pageIndex="index"
          :bio="view.bio"
          :popup="view.popup"
          :carouselImages="view.carouselImages"
          :isAudioMuted="isAudioMuted"
        />
      </section>
    </div>
    <div class="footer" :style="{visibility: !pVisible ? 'visible' : 'hidden'}">
      <button class="footer-btn" @click="isAudioMuted = !isAudioMuted">
        <svg
          v-if="isAudioMuted"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-volume-x"
        >
        <g transform="scale(1)">
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
          <line x1="23" y1="9" x2="17" y2="15" />
          <line x1="17" y1="9" x2="23" y2="15" />
          </g>
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-volume-2"
        >
        <g transform="scale(1)">
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
          <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" />
          </g>
        </svg>
      </button>
      
    <div id="id_SharingButtons" v-if="!isHidden" style="float:left;display:block">
    <social-sharing url= "http://livingintheunknown.herokuapp.com/"
                      title="Living in the Unknown"
                      description="Explore the Uighur culture through the three pillars of their identity most under attack."
                      quote="Share this documentary with your friends"
                      hashtags="Uighur"
                      twitter-user=""
                      inline-template>
      <div style="position:absolute;bottom:2em;right:1%">
          <a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https://ajcontrast.com/uighurs" style="cursor:pointer;display: block;position: relative;">
            <i class="fa fa-facebook" style="color:white"></i> 
          </a>
          <a target="_blank" href="https://twitter.com/intent/tweet?text=Living%20in%20the%20Unknown&url=https://ajcontrast.com/uighurs" style="cursor:pointer;display: block;position: relative;">
            <i class="fa fa-twitter" style="color:white"></i> 
          </a>
          <a target="_blank" href="https://api.whatsapp.com/send?text=Explore%20the%20Uighur%20culture%20through%20the%20three%20pillars%20of%20their%20identity%20most%20under%20attack.%0D%0Ahttps://ajcontrast.com/uighurs" style="cursor:pointer;display: block;position: relative;">
            <font-awesome-icon :style="{ color: 'white' }" :icon="['fab', 'whatsapp']"  />
          </a> 
      </div>
    </social-sharing>

    
    </div>

<div>
<span class="bottomcent"><span class="credits_aj" ></span></span>
</div>



    <div class="aboutshare" style="padding:3px">
      <button @click="isAboutVisible = true" class="footer-btn ">ABOUT</button>    
      <button v-on:click="isHidden = !isHidden" class="footer-btn">SHARE</button>
    </div>
    </div>
    
  </div>
</template>

<script>
import Vue from 'vue';
import VueFakeScroll from 'vue-fake-scroll'
import anime from "animejs";
import Hammer from "hammerjs";
import { debounce } from "underscore";
import SocialSharing from 'vue-social-sharing';
Vue.use(SocialSharing);

import STORIES_ICON from "../assets/images/PILLARS_ICON.png";
import STORIES_ICON_1 from "../assets/images/Icons_STORIES_WHITE.png";
import POEM from "../assets/images/poem.png";
import INTRO_ICON from "../assets/images/INTRO_ICON.png";

import MSQ1 from "../assets/images/khotan.png";
import MSQ2 from "../assets/images/yarkand.png";
import MSQ3 from "../assets/images/niya.png";

import POPUP_01 from "../assets/images/Pop-up_01.png";
import POPUP_01_1 from "../assets/images/Pop-up_01_1.png";
import POPUP_02 from "../assets/images/Pop-up_02_Chinese.png";
import POPUP_02_1 from "../assets/images/Pop-up_02_Ideology.png";
import POPUP_03 from "../assets/images/Pop-up_03.png";
import POPUP_03_1 from "../assets/images/Pop-up_03_1.png";
import POPUP_04 from "../assets/images/Pop-up_04.png";
import POPUP_05 from "../assets/images/Pop-up_05.png";
import POPUP_06 from "../assets/images/Pop-up_06.png";
import POPUP_06_1 from "../assets/images/Pop-up_06_1.png";
import POPUP_07 from "../assets/images/Pop-up_07.png";
import POPUP_07_1 from "../assets/images/Pop-up_07_1.png";
import POPUP_08 from "../assets/images/Pop-up_08.png";
import POPUP_09 from "../assets/images/Pop-up_09.png";
import POPUP_10 from "../assets/images/Pop-up_10.png";
import POPUP_10_1 from "../assets/images/Pop-up_10_1.png";
import POPUP_11 from "../assets/images/Pop-up_11.png";

import LOGO from "../assets/images/Contrast_Logo1.png";

import SLIDE1 from "../assets/images/SLIDE1.png";
import SLIDE2 from "../assets/images/SLIDE2.png";
import SLIDE3 from "../assets/images/SLIDE3.png";
import SLIDE4 from "../assets/images/SLIDE4.png";
import SLIDE5 from "../assets/images/SLIDE5.png";

import MURAL_SLIDE_1 from "../assets/images/MURAL_SLIDE_1.png";
import MURAL_SLIDE_2 from "../assets/images/MURAL_SLIDE_2.png";
import MURAL_SLIDE_3 from "../assets/images/MURAL_SLIDE_3.png";
import MURAL_SLIDE_4 from "../assets/images/MURAL_SLIDE_4.png";
import MURAL_SLIDE_5 from "../assets/images/MURAL_SLIDE_5.png";
import MURAL_SLIDE_6 from "../assets/images/MURAL_SLIDE_6.png";
import MURAL_SLIDE_7 from "../assets/images/MURAL_SLIDE_7.png";


import language_background_audio from "../assets/audios/LANGUAGE_TEMP_MUSIC.mp3";
import language_background_audio2 from "../assets/audios/Language_Track_02.mp3";
import language_background_audio3 from "../assets/audios/Language_Track_03.mp3";
import family_background_audio from "../assets/audios/FAMILY_TEMP_MUSIC.mp3";
import religion_background_audio from "../assets/audios/RELIGION_TEMP_MUSIC.mp3";
import intro_background_audio from "../assets/audios/INTRO_MUSIC.mp3";
import intro_no_lyrics_background_audio from "../assets/audios/Intro_NoLyrics.mp3";
import pillars_background_audio from "../assets/audios/ThreePillarsPage_Music.mp3";
import family_track_01 from "../assets/audios/FamilyTrack01.mp3";
import family_track_02 from "../assets/audios/FamilyTrack02.mp3";
import family_track_03 from "../assets/audios/FamilyTrack03.mp3";
import religion_track_01 from "../assets/audios/Religion_Track_01.mp3";
import religion_track_02 from "../assets/audios/Religion_Track_02.mp3";
import religion_track_03 from "../assets/audios/Religion_Track_03.mp3";

import LANGUAGE_CHARACTER_PHOTO from "../assets/images/character-photo-language.jpg";
import ISTANBUL_STREET from "../assets/images/istanbul-street.jpg";
import LAST_SLIDE from "../assets/images/last_slide.jpg";
import FAMILY_BIO_CHARACTERS from "../assets/images/family-bio-characters.jpg";
import PILLAR_3_RELIGION from "../assets/images/PILLAR3Religion_BIO.jpg";
import MOSQUE_PHOTO from "../assets/images/Mosque_Photo.jpg";
import CLOTHING_RESTRICTIONS from "../assets/images/ClothingRestrictions_BG.jpg";

var plsrotate = require('../assets/pleaserotate.min.js');
var flame = require('../assets/FlameAutoScroll.js');


export default {
  name: "home",
  components: {
    VueFakeScroll,
  },
  data() {
    return {
      'isHidden': true,
      isAboutVisible: false,
      pVisible: false,
      audios: {
        intro_background_audio: null,
        intro_no_lyrics_background_audio: null,
        language_background_audio: null,
        language_background_audio2: null,
        language_background_audio3: null,
        family_background_audio: null,
        religion_background_audio: null,
        pillars_background_audio: null
      },
      isAudioMuted: false,
      playing_audio: null,
      isStarted: false,
      ICON: STORIES_ICON,
      LOGO: LOGO,
      PHOTO: LAST_SLIDE,
      views:[
        {
          audio: "intro_background_audio",
          component: () => import("../components/PageOne.vue")
        },
        {
          videos: ["345440635.hd.mp4?s=ec08f2aacc02c252e9ddc0f5ba3f0a4e5b41d90a&profile_id=174"],
          showcontrols: false,
          poster:"804135093.jpg",
          loop: true,
          audio: "intro_no_lyrics_background_audio",
          component: () => import("../components/AppSlide.vue"),
          tapes: [
            {
              img: "TITLE_CARD-01",
              Y: "5%",
              X: "0%",
              isActive:false,
              mustPause:false
            },
            {
              img: "TITLE_CARD-02",
              Y: "5%",
              X: "0%",
              isActive:false,
              mustPause:false
            }
          ]
        },
        {
          videos: ["346702899.hd.mp4?s=44fa7f3e30f45ab4c1b9874c059e741d61c43a0a&profile_id=174"],
          showcontrols: false,
          loop: false,
          poster: "803611267.jpg",
          showfirsttape: false,
          clicktoplay: false,
          noscroll: true,
          disablebackscroll: true,
          tapes: [
            {
              img: "TITLE_CARD-03",
              Y: "0%",
              X: "100%",
              time:2.50,
              isActive:false,
              readMore:false,
              mustPause:true
            },
            {
              img: "TITLE_CARD-04",
              Y: "0%",
              X: "100%",
              time:7.80,
              isActive:false,
              readMore:false,
              mustPause:true
            },
            {
              img: "TITLE_CARD-05",
              Y: "0%",
              X: "100%",
              time:12.00,
              isActive:false,
              readMore:true,
              mustPause:true
            }
          ],
          popup: {
            tabs: [
              {
                //title: "Who are Uighurs",
                content:
                  "<p><img style='display:block;margin:0 auto;' fluid src="+POPUP_01+" /></p> "
              },
              /*{
                title: "Oil Rich “New Frontier”",
                content:
                  "<p><img style='display:block;margin:0 auto;' fluid src="+POPUP_01_1+" /></p>"
              }*/
            ]
          },
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["347899083.hd.mp4?s=66b34461039e6a1e680ea9564ae31a7571752aee&profile_id=174"],
          poster: "347899083.jpg",
          component: () => import("../components/AppSlide.vue"),
          showcontrols: false,
          loop: true,
          tapes: [
            {
              img: "TITLE_CARD-06",
              Y: "0%",
              X: "50%",
              isActive:false,
              mustPause:false
            },
            {
              img: "TITLE_CARD-07",
              Y: "0%",
              X: "50%",
              mustPause:false
            },
            {
              img: "TITLE_CARD-08",
              Y: "0%",
              X: "50%",
              mustPause:false
            },
            {
              img: "TITLE_CARD-09",
              Y: "0%",
              X: "50%",
              mustPause:false
            }
          ]
        },
        {
          videos: ["346184196.hd.mp4?s=dd8349dc01825f245be2b0207c80184fe9307886&profile_id=174"],
          poster: "346184196.jpg",
          noaudio: true,
          showcontrols: true,
          loop: false,
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["345467379.hd.mp4?s=2eb9b87ece395a9d70f25d02beef9ab789dec349&profile_id=174"],
          showcontrols: false,
          poster: "345467379.jpg",
          loop: true,
          tapes: [
            {
              img: "TITLE_CARD-10",
              Y: "50%",
              X: "50%",
              isActive:false,
              mustPause:false
            },
            {
              img: "TITLE_CARD-11",
              Y: "50%",
              X: "50%",
            },
            {
              img: "TITLE_CARD-12",
              Y: "50%",
              X: "50%",
            },
            {
              img: "TITLE_CARD-13",
              Y: "50%",
              X: "50%",
            }
          ],
          component: () => import("../components/AppSlide.vue")
        },
        {
          audio: "pillars_background_audio",
          component: () => import("../components/Pillars.vue")
        },
        {
          audio: "language_background_audio",
          showcontrols: true,
          loop: false,
          videos: ["345472223.hd.mp4?s=c12869f0f694f59447043bf6c05a5564158ecb0c&profile_id=174"],
          poster: "345472223.jpg",
          component: () => import("../components/AppSlide.vue")
        },
        {
          photo: LANGUAGE_CHARACTER_PHOTO,
          showTape: true,
          tapes: [
            {
              img: "TITLE_CARD-14",
              Y: "50%",
              X: "95%",
              isActive:false,
              mustPause:false,
              showBio:true
            }
          ],
          bio: {
            name: "ILMINUR MUTELLIP",
            age: "22 years old",
            hometown: "Hami [Chinese]; Kumul [Uighur]",
            arrived: "September 2016 ",
            family: [
              "Mother released from detention, lives in China",
              "Father detained in China",
              "Two sisters live in China"
            ]
          },
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["345724331.hd.mp4?s=dd818ba198efe3c5aabc132bbf192102dc7f9bee&profile_id=174"],
          poster: "345724331.jpg",
          showcontrols: true,
          loop: false,
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["345727869.hd.mp4?s=96c5e525ccd0b67491a8bda3ab8786515168c476&profile_id=174"],
          poster: "345727869.jpg",
          showcontrols: false,
          loop: true,
          tapes: [
            {
              img: "TITLE_CARD-15",
              Y: "50%",
              X: "50%",
              isActive:false,
              mustPause:false,
            },
            {
              img: "TITLE_CARD-16",
              Y: "50%",
              X: "50%",
            },
            {
              img: "TITLE_CARD-17",
              readMore: true,
              Y: "50%",
              X: "50%",
            }
          ],
          popup: {
            tabs: [
              {
                //title: "Chinese as the Dominant Language",
                content:
                  "<p><img style='display:block;margin:0 auto;' fluid src="+POPUP_02+" /></p> "
              },
              /*{
                title: "Chinese Ideology at Schools",
                content:
                  "<img style='display:block;margin:0 auto;' fluid src="+POPUP_02_1+" />"
              }*/
            ]
          },
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["347506897.hd.mp4?s=0cee507db54cd4fb1da5fff46d43635149f0ccd3&profile_id=174"],
          poster: "347506897.jpg",
          showcontrols: false,
          loop: true,
          tapes: [
            {
              img: "TITLE_CARD-18",
              Y: "0%",
              X: "100%",
              isActive:false
            },
            {
              img: "TITLE_CARD-19",
              Y: "0%",
              X: "100%",
            }
          ],
          component: () => import("../components/AppSlide.vue")
        },
        {
          withCarousel: true,
          photo: ISTANBUL_STREET,
          photoCard: "TITLE_CARD-47",
          photoCards: ["TITLE_CARD-47", "TITLE_CARD-47", "TITLE_CARD-47", "TITLE_CARD-47", "TITLE_CARD-47"],
          //carouselImages: [SLIDE1,SLIDE2,SLIDE3,SLIDE4,SLIDE5],
          carouselImages:[
            {
              img: SLIDE1,
              card: "SLIDE1_TEXT"
            },
            {
              img: SLIDE2,
              card: "SLIDE2_TEXT"
            },
            {
              img: SLIDE3,
              card: "SLIDE3_TEXT"
            },
            {
              img: SLIDE4,
              card: "SLIDE4_TEXT"
            },
            {
              img: SLIDE5,
              card: "SLIDE5_TEXT"
            },

          ],
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["345474463.hd.mp4?s=2268639533f76ffa8c4899493c0deea0d6fca620&profile_id=174"],
          poster: "345474463.jpg",
          showcontrols: true,
          loop: false,
          component: () => import("../components/AppSlide.vue")
        },
        {
          audio: "language_background_audio2",
          showcontrols: false,
          loop: true,
          videos: ["347276001.hd.mp4?s=3747472d9f50ec49dfd4eb977fe3fdd3015167e1&profile_id=174"],
          poster: "347276001.jpg",
          tapes: [
            {
              img: "TITLE_CARD-20",
              Y: "5%",
              X: "0%",
              isActive:false,
              mustPause:false
            },
            {
              img: "TITLE_CARD-21",
              Y: "5%",
              X: "0%",
            },
            {
              img: "TITLE_CARD-22",
              readMore: true,
              Y: "5%",
              X: "0%",
            }
          ],
          popup: {
            tabs: [
              {
                //title: "Detention Centers in Xinjang",
                content:
                  "<p><img style='display:block;margin:0 auto;' fluid src="+POPUP_03+" /></p>"
              },
              /*{
                title: "“Transformation Through Education”",
                content:
                  "<p><img style='display:block;margin:0 auto;' fluid src="+POPUP_03_1+" /></p>"
              }*/
            ]
          },
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["348013079.sd.mp4?s=a082cbe5172217c573843ba7f0e0ce25f91dbe53&profile_id=165"],
          poster: "348013079.jpg",
          showcontrols: false,
          showfirsttape: false,
          clicktoplay: false,
          noscroll: true,
          disablebackscroll: true,
          pauses: [
            {
              time: 3.65,
              isActive: false
            },
            {
              time: 8.80,
              isActive: false
            }
            ,
            {
              time: 13.50,
              isActive: false
            }
          ],
          tapes: [
            {
              img: "TITLE_CARD-23",
              Y: "0%",
              X: "100%",
              isActive:false,
              time: 14.3,
              mustPause:true,
              readMore:true
            }
          ],
          popup : {
            tabs : [
              {
                //title : "Violent Incidents",
                content :
                "<p><img style='display:block;margin:0 auto;' fluid src="+POPUP_04+" /></p>"
              }
            ]
          },
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["347316518.hd.mp4?s=a10c1c98879cb8bc7d7be6530f1276fbcdf797ba&profile_id=174"],
          poster: "347316518.jpg",
          showcontrols: false,
          loop: true,
          tapes: [
            {
              img: "TITLE_CARD-24",
              Y: "50%",
              X: "50%",
              readMore: true,
              isActive:false,
              mustPause:false
            },
            {
              img: "TITLE_CARD-25",
              Y: "50%",
              X: "50%",
              readMore:true
            }
          ],
          popup : {
            tabs : [
              {
                //title : "“People’s War on Terror”",
                content :
                "<p><img style='display:block;margin:0 auto;' fluid src="+POPUP_05+" /></p>"
              }
            ]
          },
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["347311837.hd.mp4?s=07f2389cc4b0de6f7f2bd06df78c16f26191a90b&profile_id=174"],
          poster: "347311837.jpg",
          showcontrols: true,
          loop: false,
          noaudio: true,
          component: () => import("../components/AppSlide.vue")
        },
        {
          audio: "language_background_audio3",
          showcontrols: true,
          loop: false,
          tapes: [
            {
              img: "IPoem",
              Y: "0%",
              X: "100%",
              readMore: true,
              isActive:false,
              mustPause:false
            }
          ],
          videos: ["345866223.hd.mp4?s=969d309c0e0bcd956859999ea8d5ca41bb379ff6&profile_id=174"],
          poster: "345866223.jpg",
          popup : {
            tabs : [
              {
                //title : "Poem",
                content : "<img style='display:block;' fluid src="+POEM+" />"
              }
            ]
          },
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["347321197.hd.mp4?s=287414991e7bfeb75ca4b6c07a039c5f897a5252&profile_id=174"],
          poster: "347321197.jpg",
          showcontrols: false,
          loop: true,
          popup : {},
          popupVideo: "345479013",
          tapes: [
            {
              watchMore: true,
              img: "TITLE_CARD-26",
              img2: "TITLE_CARD-26_apple",
              Y: "50%",
              X: "50%",
              isActive:false,
              mustPause:false
            }
          ],
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["345877269.hd.mp4?s=5c22c87d0867af3f114fb9b75346e449aee30fbf&profile_id=174"],
          poster: "345877269.jpg",
          showcontrols: true,
          loop: false,
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["345906029.hd.mp4?s=48d1cad7d60bde2b1c05437acd89c41be14b7671&profile_id=174"],
          poster: "345906029.jpg",
          showcontrols: true,
          loop: false,
          audio: "family_track_01",
          component: () => import("../components/AppSlide.vue")
        },
        {
          photo: FAMILY_BIO_CHARACTERS,
          audio: "family_track_01",
          showTape: true,
          component: () => import("../components/AppSlide.vue"),
          tapes: [
            {
              img: "TITLE_CARD-27",
              Y: "50%",
              X: "95%",
              isActive:false,
              mustPause:false,
              showBio:true
            }
          ],
          bio: {
            name: "MUNAWWAR AND DILNUR NURMUHAMMAD",
            age: "18 and 16 years old",
            hometown: "Hotan",
            arrived: "June 2017",
            family: [
              "Mother disappeared in China",
              "Father jailed in China",
              "Seven siblings live in China"
            ]
          }
        },
        {
          videos: ["345906225.hd.mp4?s=60a42a9c8920e48274d8b6ab07d78317fad54dd8&profile_id=174"],
          poster: "345906225.jpg",
          showcontrols: true,
          loop: false,
          audio: "family_track_01",
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["347335320.hd.mp4?s=20576c05887b2669648d420f68b6b762d0697124&profile_id=174"],
          poster: "347335320.jpg",
          showcontrols: false,
          loop: true,
          audio: "family_track_01",
          component: () => import("../components/AppSlide.vue"),
          tapes: [
            {
              img: "TITLE_CARD-28",
              Y: "50%",
              X: "50%",
            },
            {
              img: "TITLE_CARD-29",
              Y: "50%",
              X: "50%",
            },
            {
              img: "TITLE_CARD-30",
              Y: "50%",
              X: "50%",
            }
          ]
        },
        {
          videos: ["345906357.hd.mp4?s=b3b5a0bd5f46a400145aea19478afb7d1c578c01&profile_id=174"],
          poster: "345906357.jpg",
          showcontrols: true,
          loop: false,
          noaudio: true,
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["347343779.hd.mp4?s=4dceedd0bc082dd76367303784568a9263423327&profile_id=174"],
          poster: "347343779.jpg",
          showcontrols: false,
          loop: true,
          audio: "family_track_02",
          component: () => import("../components/AppSlide.vue"),
          tapes: [
            {
              img: "TITLE_CARD-31",
              Y: "0%",
              X: "100%",
              isActive:false,
              mustPause:false,
              readMore:true
            }
          ],
          popup: {
            tabs: [
              {
                //title: "China’s Control of Uighur Communication",
                content:
                  "<p><img style='display:block;margin:0 auto;' fluid src="+POPUP_06+" /></p>"
              },
              /*{
                title: "China’s Internet Authority Goes Global",
                content:
                  "<p><img style='display:block;margin:0 auto;' fluid src="+POPUP_06_1+" /></p>"
              }*/
            ]
          }
        },
        {
          videos: ["347345805.hd.mp4?s=f1e623f2e02957f6df1745c1d5416d1097bac992&profile_id=174"],
          poster: "347345805.jpg",
          showcontrols: false,
          loop: true,
          audio: "family_track_02",
          component: () => import("../components/AppSlide.vue"),
          tapes: [
            {
              img: "TITLE_CARD-32",
              Y: "50%",
              X: "50%",
              isActive:false,
              mustPause:false
            },
            {
              img: "TITLE_CARD-33",
              Y: "50%",
              X: "50%",
            }
          ]
        },
        {
          videos: ["347277147.hd.mp4?s=0e51b32ebbca4344cfd3016d008835359c13012c&profile_id=174"],
          poster: "347277147.jpg",
          showcontrols: false,
          loop: false,
          showfirsttape: false,
          noscroll: true,
          clicktoplay: false,
          audio: "family_track_02",
          pauses: [
            {
              time: 4.00,
              isActive: false
            },
            {
              time: 6.69,
              isActive: false
            }
          ],
          tapes: [
            {
              img: "TITLE_CARD-34",
              Y: "0%",
              X: "100%",
              time:9.40,
              readMore:true,
              mustPause:true,
              isActive:false,
            }
          ],
          component: () => import("../components/AppSlide.vue"),
          popup: {
            tabs: [
              {
                //title: "Policing State",
                content:
                  "<p><img style='display:block;margin:0 auto;' fluid src="+POPUP_07+" /></p>"
              },
              /*{
                title: "Surveillance Laboratory",
                content:
                  "<p><img style='display:block;margin:0 auto;' fluid src="+POPUP_07_1+" /></p>"
              }*/
            ]
          }
        },
        {
          videos: ["347596908.hd.mp4?s=d77152d74d8121ccc03f48ffbecea3f2df9511f7&profile_id=174"],
          poster: "347596908.jpg",
          showcontrols: true,
          loop: false,
          audio: "family_track_03",
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["345450295.hd.mp4?s=a8b8377f6f34a30a46ba045082ad8d9b43a96f5b&profile_id=174"],
          poster: "345450295.jpg",
          showcontrols: true,
          loop: false,
          audio : "family_track_03",
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["347589306.hd.mp4?s=3b833252947816f65e6c083323881ffec0cf0b1e&profile_id=174"],
          poster: "347589306.jpg",
          audio: "family_track_03",
          showcontrols: false,
          loop: true,
          component: () => import("../components/AppSlide.vue"),
          popup: {
            tabs: [
              {
                //title: "Social Re-engineering of Uighur Cities and Homes",
                content:
                  "<p><img style='display:block;margin:0 auto;' fluid src="+POPUP_08+" /></p>"
              }
            ]
          },
          tapes: [
            {
              img: "TITLE_CARD-35",
              Y: "90%",
              X: "0%",
              isActive:false,
              mustPause:false
            },
            {
              img: "TITLE_CARD-36",
              Y: "90%",
              X: "0%",
            },
            {
              img: "TITLE_CARD-37",
              Y: "90%",
              X: "0%",
            },
            {
              img: "TITLE_CARD-38",
              Y: "90%",
              X: "0%",
              readMore:true
            }
          ]
        },
        {
          videos: ["345906580.hd.mp4?s=f942ffe21d5438de9cec9f915fc8dff805dbcaad&profile_id=174"],
          poster: "345906580.jpg",
          showcontrols: true,
          loop: false,
          audio: "family_track_03",
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["347591312.hd.mp4?s=5498c2e782736985a29cc2f1384409ab8eb0d78d&profile_id=174"],
          poster: "347591312.jpg",
          audio: "family_track_03",
          showcontrols: false,
          loop: true,
          component: () => import("../components/AppSlide.vue"),
          tapes: [
            {
              img: "TITLE_CARD-39",
              Y: "5%",
              X: "0%",
              isActive:false,
              mustPause:false
            },
            {
              img: "TITLE_CARD-40",
              Y: "5%",
              X: "0%",
            }
          ]
        },
        {
          videos: ["345906666.hd.mp4?s=571a52c2096e8d64d0b3477fd9d2211799a761d6&profile_id=174"],
          poster: "345906666.jpg",
          showcontrols: true,
          loop: false,
          audio: "family_track_03",
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["345950179.hd.mp4?s=5a5db15e0d349fe33748d4c72c1173596e804d39&profile_id=174"],
          poster: "345950179.jpg",
          showcontrols: true,
          loop: false,
          audio: "religion_track_01",
          component: () => import("../components/AppSlide.vue")
        },
        {
          photo: PILLAR_3_RELIGION,
          showTape: true,
          bio: {
            name: "SHEHIDE MUHEMMET",
            age: "18 years old",
            hometown: "Shache [Chinese]; Yarkant [Uighur]",
            arrived: "March 2016",
            family: [
              "Father disappeared in China",
              "Brother disappeared in China",
              "Mother and four siblings live in Istanbul"
            ]
          },
          tapes: [
            {
              img: "TITLE_CARD-41",
              Y: "50%",
              X: "95%",
              isActive:false,
              mustPause:false,
              showBio:true
            }
          ],
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["345950262.hd.mp4?s=863da05bf9759ddc9a0b7e072e7e567a1dad4217&profile_id=174"],
          poster: "345950262.jpg",
          showcontrols: true,
          loop: false,
          popup: {
            tabs : [
              {
                title: "Uighurs and Islam",
                content :
                "<p><img style='display:block;margin:0 auto;' fluid src="+POPUP_09+" /></p>"
              }
            ]
          },
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["345952630.hd.mp4?s=fa34a711da1601fd4581c372049c3dfa00890fab&profile_id=174"],
          poster: "345952630.jpg",
          showcontrols: true,
          loop: false,
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["347595375.hd.mp4?s=411001a47b1abcb85c4d22f10acd0baba092c163&profile_id=174"],
          poster: "347595375.jpg",
          showcontrols: false,
          loop: true,
          component: () => import("../components/AppSlide.vue"),
          tapes: [
            {
              img: "TITLE_CARD-42",
              Y: "5%",
              X: "0%",
              isActive:false,
              mustPause:false
            },
            {
              img: "TITLE_CARD-43",
              Y: "5%",
              X: "0%",
            },
            {
              img: "TITLE_CARD-44",
              Y: "5%",
              X: "0%",
              readMore:true
            }
          ],
          popup: {
            tabs: [
              {
                //title: "Destruction of mosques and Uighur shrines",
                content:
                  "<p><img style='display:block;margin:0 auto;' fluid src="+POPUP_10+" /></p>"
              },
              /*{
                title: "China’s devotion to “sinicize” religion",
                content:
                  "<p><img style='display:block;margin:0 auto;' fluid src="+POPUP_10_1+" /></p>"
              }*/
            ]
          }
        },
        {
          videos: ["347597946.hd.mp4?s=a22882dba4c3726508acd76f24a1dc3b577878ec&profile_id=174"],
          poster: "347597946.jpg",
          showcontrols: true,
          loop: false,
          component: () => import("../components/AppSlide.vue")
        },
        {
          photo: CLOTHING_RESTRICTIONS,
          audio: "religion_track_02",
          tapes: [
            {
              img: "TITLE_CARD-45",
              Y: "50%",
              X: "50%",
              isActive:false,
              mustPause:false
            },
            {
              img: "TITLE_CARD-46",
              Y: "50%",
              X: "50%",
              readMore:true
            }
          ],
          popup: {
            tabs: [
              {
                //title: "Restricted Religious Practices",
                content:
                  "<p><img style='display:block;margin:0 auto;' fluid src="+POPUP_11+" /></p>"
              }
            ]
          },
          component: () => import("../components/AppSlide.vue")
        },
        {
          withCarousel: true,
          photo: ISTANBUL_STREET,
          photoCard: "TITLE_CARD-47",
          carouselImages:[
            {
              img: MURAL_SLIDE_1,
              card: "MURAL_SLIDE_1_TEXT"
            },
            {
              img: MURAL_SLIDE_2,
              card: "MURAL_SLIDE_2_TEXT"
            },
            {
              img: MURAL_SLIDE_3,
              card: "MURAL_SLIDE_3_TEXT"
            },
            {
              img: MURAL_SLIDE_4,
              card: "MURAL_SLIDE_4_TEXT"
            },
            {
              img: MURAL_SLIDE_5,
              card: "MURAL_SLIDE_5_TEXT"
            },
            {
              img: MURAL_SLIDE_6,
              card: "MURAL_SLIDE_6_TEXT"
            },
            {
              img: MURAL_SLIDE_7,
              card: "MURAL_SLIDE_7_TEXT"
            },
          ],
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["345950287.hd.mp4?s=5a41e2047761dfe9481bc1d9ebecaccfbbec31cf&profile_id=174"],
          poster: "345950287.jpg",
          showcontrols: true,
          loop: false,
          audio: "religion_track_03",
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["347602218.hd.mp4?s=dea14669ba70068272fb02a9531fe6fc1e242d8c&profile_id=174"],
          poster: "347602218.jpg",
          showcontrols: false,
          loop: true,
          component: () => import("../components/AppSlide.vue"),
          tapes: [
            {
              img: "TITLE_CARD-48",
              Y: "0%",
              X: "100%",
              isActive:false,
              mustPause:false
            },
            {
              img: "TITLE_CARD-49",
              Y: "0%",
              X: "100%",
            },
            {
              img: "TITLE_CARD-50",
              Y: "0%",
              X: "100%",
            }
          ]
        },
        {
          videos: ["345950377.hd.mp4?s=4eace7bba10bd49ec2dce26cd9a2051a4482b04e&profile_id=174"],
          showcontrols: true,
          poster: "345950377.jpg",
          loop: false,
          component: () => import("../components/AppSlide.vue")
        },
        {
          videos: ["348570864.hd.mp4?s=14442dee90b87c890a1440f09575beeba23d9234&profile_id=174"],
          poster: "348570864.jpg",
          showcontrols: true,
          loop: false,
          audio: "intro_background_audio",
          component: () => import("../components/AppSlide.vue")
        },
        {
          photo: LAST_SLIDE,
          component: () => import("../components/LastSlide.vue")
        }
      ],
      current: 0,
      visitedPillars: []
    };
  },
  created() {
    this.scroll = debounce(this.scroll, 100);
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  watch: {
    isAudioMuted(val) {
      if (val) {
        this.audios.language_background_audio.pause();
        this.audios.language_background_audio2.pause();
        this.audios.language_background_audio3.pause();
        this.audios.religion_background_audio.pause();
        this.audios.family_background_audio.pause();
        this.audios.intro_background_audio.pause();
        this.audios.intro_no_lyrics_background_audio.pause();
        this.audios.pillars_background_audio.pause();
        this.audios.family_track_01.pause();
        this.audios.family_track_02.pause();
        this.audios.family_track_03.pause();
        this.audios.religion_track_01.pause();
        this.audios.religion_track_02.pause();
        this.audios.religion_track_03.pause();

        /*for (var key in this.audios) {
        this.audios[key].pause();
        }*/
      } else {
        
        this.audios[this.playing_audio].play();
      }
    },
    current(val) {
      console.log("current" + val);
      if (val === 6) {
        this.ICON = INTRO_ICON;
      }
      else
      {
        this.ICON = STORIES_ICON;
      }

      if (this.views[val] && this.views[val].audio) {
        if (this.views[val].audio !== this.playing_audio) {
          this.audios.language_background_audio.pause();
          this.audios.language_background_audio2.pause();
          this.audios.language_background_audio3.pause();
          this.audios.religion_background_audio.pause();
          this.audios.family_background_audio.pause();
          this.audios.intro_background_audio.pause();
          this.audios.intro_no_lyrics_background_audio.pause();
          this.audios.pillars_background_audio.pause();
          this.audios.family_track_01.pause();
          this.audios.family_track_02.pause();
          this.audios.family_track_03.pause();
          this.audios.religion_track_01.pause();
          this.audios.religion_track_02.pause();
          this.audios.religion_track_03.pause();
          if (!this.isAudioMuted)
          this.audios[this.views[val].audio].play();
          this.playing_audio = this.views[val].audio;
        }
      }

      this.updateNav();
    }
  },
  computed: {
    // a computed getter
    navBar: function () {
      // `this` points to the vm instance

      let navs = [];

    if ((this.current >= 1) && (this.current <= 5))
    {
      navs = [
        {
          title: "Istanbul",
          index: 1
        },
        {
          title: "Map",
          index: 2
        },
        {
          title: "Xinjiang",
          index: 3
        },
        {
          title: "China's Response",
          index: 4
        },
        {
          title: "Children",
          index: 5
        }
      ];
    }
    else if ((this.current >= 7) && (this.current <= 20))
    {
      navs = [
        {
          title: "Calligraphy",
          index: 7
        },
        {
          title: "Language Restrictions",
          index: 10
        },
        {
          title: "Detained Elite",
          index: 11
        },
        {
          title: "Nightmare",
          index: 13
        },
        {
          title: "Detention",
          index: 14
        },
        {
          title: "Violence",
          index: 15
        },
        {
          title: "China's Response",
          index: 17
        },
        {
          title: "Poetry",
          index: 18
        },
        {
          title: "Future",
          index: 20
        }
      ];
    }
    else if ((this.current >= 21) && (this.current <= 34))
    {
      navs = [
        {
          title: "Sisters",
          index: 21
        },
        {
          title: "Egypt",
          index: 23
        },
        {
          title: "Communication",
          index: 25
        },
        {
          title: "Diaspora",
          index: 26
        },
        {
          title: "Surveillance",
          index: 27
        },
        {
          title: "Policing",
          index: 28
        },
        {
          title: "Memories",
          index: 30
        },
        {
          title: "Cemetery",
          index: 31
        },
        {
          title: "Turkey",
          index: 32
        },
        {
          title: "Protest",
          index: 33
        },
        {
          title: "Future",
          index: 34
        }
      ];
    }
    else if ((this.current >= 35) && (this.current <= 45))
    {
      navs = [
        {
          title: "Quran Course",
          index: 35
        },
        {
          title: "Islam",
          index: 37
        },
        {
          title: "Memories",
          index: 38
        },
        {
          title: "Mosques",
          index: 39
        },
        {
          title: "Religious Restrictions",
          index: 41
        },
        {
          title: "Murals",
          index: 42
        },
        {
          title: "Father",
          index: 43
        },
        {
          title: "Uighurs Abroad",
          index: 44
        },
        {
          title: "Future",
          index: 45
        }
      ];
    }
      return navs;
    }
  },
  methods: {
    handleResize(event) {
      // if user is not on mobile, return. we don't care
      if (window.innerWidth > 500) return;

      if (window.screen.orientation.type === "portrait-primary") {
      }
      // if (screen.orientation)
    },
    playAudio(name) {
      this.playing_audio = name;

      if (!this.isAudioMuted)
      this.audios[name].play();
    },
    stopAudio(name) {
      this.audios[name].pause();
    },
    stopAllAudio(){
      for (var key in this.audios) {
        this.audios[key].pause();
    if (this.audios.hasOwnProperty(key)) {           
        
    }
};     
    },
    togglePillars() {
      
      
      //this.ICON = INTRO_ICON;
      if (this.current === 6)
      {
      
      this.current = 1;
      }
      else
      this.current = 6;
    },
    scroll(event) {
      this.isAudioMuted = !this.isAudioMuted;

      this.isAudioMuted = !this.isAudioMuted;

      if (event.wheelDelta > 0) {
        this.prev();
      } else {
        this.next();
      }
    },
    go(where) {
      this.current = where;
      
      if (!this.visitedPillars.includes(where)) {
        this.visitedPillars = [...this.visitedPillars, where];
      }
      if (this.players) {
        
        this.players.map(pl => {
          pl.volume = 10;
        });
      }
    },
    next() {
      if ([20, 34, 45].includes(this.current)) {
        let checker = (arr, target) => target.every(v => arr.includes(v));

        if (checker(this.visitedPillars, [20, 34, 45])) {
          this.current = 46;
          return;
        } else {
          this.current = 6;
          return;
        }
      }

      if (this.current === this.views.length) {
        this.current = 6;
        return;
      }

      
      this.current += 1;
    },
    prev() {
      
      if (this.current === -1) return;
      this.current -= 1;
    },
    updateNav(isUp) {
      let navs = document.querySelectorAll("nav li");
      if (navs) {
        [...navs].forEach(el => {
          el.setAttribute(
            "style",
            "background-color: rgba(255, 255, 255, 0.25)"
          );
        });
      }

      (that => {
        setTimeout(() => {
          let currentNav = document.querySelector(
            `nav li[value="${that.current}"]`
          );
          if (!currentNav) return;
          currentNav.setAttribute("style", "background-color: white");
        }, 500);
      })(this);
    },
    loadBackgroundAudio(name, audio) {
      this.audios[name] = new Audio(audio);
      if (typeof this.audios[name].loop == "boolean") {
        this.audios[name].loop = true;
      } else {
        this.audios[name].addEventListener(
          "ended",
          function() {
            this.currentTime = 0;
            this.play();
          },
          false
        );
      }
    }
  },
  mounted() {
    this.current = 0;

    this.loadBackgroundAudio(
      "language_background_audio",
      language_background_audio
    );

    this.loadBackgroundAudio(
      "language_background_audio2",
      language_background_audio2
    );

    this.loadBackgroundAudio(
      "language_background_audio3",
      language_background_audio3
    );

    this.loadBackgroundAudio(
      "family_track_01",
      family_track_01
    );
    this.loadBackgroundAudio(
      "family_track_02",
      family_track_02
    );
    this.loadBackgroundAudio(
      "family_track_03",
      family_track_03
    );

     this.loadBackgroundAudio(
      "religion_track_01",
      religion_track_01
    );
    this.loadBackgroundAudio(
      "religion_track_02",
      religion_track_02
    );
    this.loadBackgroundAudio(
      "religion_track_03",
      religion_track_03
    );

    

    this.loadBackgroundAudio(
      "religion_background_audio",
      religion_background_audio
    );

    this.loadBackgroundAudio(
      "family_background_audio",
      family_background_audio
    );

    this.loadBackgroundAudio("intro_background_audio", intro_background_audio)
    this.loadBackgroundAudio("intro_no_lyrics_background_audio", intro_no_lyrics_background_audio);

    this.loadBackgroundAudio("pillars_background_audio", pillars_background_audio);
  }
};
</script>

<style>
</style>
